export enum NdfFormMode {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
}
